import {
  // eslint-disable-next-line @wordpress/no-unsafe-wp-apis
  __experimentalLinkControl as LinkControl,
} from '@wordpress/block-editor';
const {
  i18n: { __ },
  components: { ToggleControl },
} = wp;

const RedirectSettings = (props) => {
  const { attributes, setAttributes } = props;
  const { redirect } = attributes;

  return (
    <>
      <LinkControl
        searchInputPlaceholder="Type the Redirect URL here..."
        value={redirect.redirectURL}
        settings={[]}
        onChange={(selection) => {
          setAttributes({
            redirect: {
              ...redirect,
              redirectURL: {
                ...selection,
                title: selection.url,
              },
            },
          });
        }}
        onRemove={() =>
          setAttributes({
            redirect: {
              redirectURL: {},
            },
          })
        }
        withCreateSuggestion={false}
      />
      <ToggleControl
        label={__('Open in a new tab', 'b3rg')}
        checked={redirect.linkOpenType}
        onChange={(newValue) => {
          setAttributes({
            redirect: {
              ...redirect,
              linkOpenType: newValue,
            },
          });
        }}
      />
    </>
  );
};

export default RedirectSettings;
